import React from 'react';
import { Form } from 'semantic-ui-react';
import { createStyles, withStyles } from '@material-ui/core/styles';

import FilterCardContainer from '../FilterComponents/FilterCardContainer';
import FilterCardKeyArray from '../FilterComponents/FilterCardKeyArray';
import FilterCardSelectRefCustom from '../FilterComponents/FilterCardSelectRefCustom';
import FilterCardSelectRef from '../FilterComponents/FilterCardSelectRef';

const styles = createStyles({
  header: {
    display: 'inline-block',
    verticalAlign: 'top'
  }
});

type Props = {
  record: any,
  resource: string
};

const CommonFiltersColumn3 = (props: Props) => (
  <div >
    <Form.Field>
      <FilterCardSelectRefCustom
        reference="helpers/domains"
        resource={props.resource}
        rootName="segment_attributes.filter_page_domain_attributes"
        sort={{ field: 'domain', order: 'ASC' }}
        title="Domains"
        values={props.record.segment_attributes &&
          props.record.segment_attributes.filter_page_domain_attributes &&
          props.record.segment_attributes.filter_page_domain_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardKeyArray
        record={props.record}
        rootName="segment_attributes.filter_page_url_attributes"
        title="Page URL"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_page_url_attributes && props.record.segment_attributes.filter_page_url_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardKeyArray
        record={props.record}
        rootName="segment_attributes.filter_page_url_path_attributes"
        title="Page URL Path"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_page_url_path_attributes && props.record.segment_attributes.filter_page_url_path_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardSelectRef
        reference="helpers/placement_codes"
        resource={props.resource}
        rootName="segment_attributes.filter_placement_id_attributes"
        sort={{ field: 'name', order: 'ASC' }}
        title="Placement IDs"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_placement_id_attributes && props.record.segment_attributes.filter_placement_id_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardKeyArray
        record={props.record}
        rootName="segment_attributes.filter_query_string_attributes"
        title="Query Strings"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_query_string_attributes && props.record.segment_attributes.filter_query_string_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardKeyArray
        record={props.record}
        rootName="segment_attributes.filter_page_id_attributes"
        title="Page IDs"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_page_id_attributes && props.record.segment_attributes.filter_page_id_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardKeyArray
        record={props.record}
        rootName="segment_attributes.filter_target_attributes"
        title="Targets"
        values={props.record.segment_attributes && props.record.segment_attributes.filter_target_attributes && props.record.segment_attributes.filter_target_attributes.values} /><br />
    </Form.Field>
    <Form.Field>
      <FilterCardContainer
        record={props.record}
        rootName="segment_attributes.filter_adunit_attributes"
        title="Ad Unit" /><br />
    </Form.Field>
  </div>
);

export default withStyles(styles)(CommonFiltersColumn3);



// WEBPACK FOOTER //
// ./src/views/Common/Filters/Column3.tsx